import NewMeetingComment from './NewMeetingComment'

export default class UpdateMeetingComment extends NewMeetingComment {
    deleteFileNumberList: number[]
    version: number

    constructor(content: string, deleteFileNumberList: number[], version: number) {
        super(content)
        this.deleteFileNumberList = deleteFileNumberList
        this.version = version
    }
}
